import { render } from "./ProfileUserMenu.vue?vue&type=template&id=99d256e2"
import script from "./ProfileUserMenu.vue?vue&type=script&lang=js"
export * from "./ProfileUserMenu.vue?vue&type=script&lang=js"

import "./ProfileUserMenu.vue?vue&type=style&index=0&id=99d256e2&lang=less"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__